module.exports = __webpack_public_path__ + "static/media/National-ThaiWater-User-Manual.e2adc3fd.pdf";